export const formatURLLabel = (label: string) =>
  (label || '').replace(/^(https?:\/\/)?(www\.?)?/, '').replace(/\/+$/, '');
